export default __webpack_public_path__ + "static/media/Armguards of the Assailant.b91ba00f.jpg";